import { configureStore } from '@reduxjs/toolkit';
import mapReducer from './features/map/mapSlice'
import mcpReducer from './features/map/selectedMcpSlice'
import modalReducer from './features/map/modalSlice'

export const store = configureStore({
  reducer: {
    map: mapReducer,
    selectedMcp: mcpReducer,
    modal: modalReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
